import { render, staticRenderFns } from "./FlashCardAnswerBtn.vue?vue&type=template&id=22b63e40&"
import script from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardAnswerBtn?vue&type=script&lang=js&"
export * from "@/scripts/FlashCard/FlashCardDetail/components/FlashCardFooter/FlashCardAnswerBtn?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports